import { render, staticRenderFns } from "./InvoiceParameterInput.vue?vue&type=template&id=4b5edce6&"
import script from "./InvoiceParameterInput.vue?vue&type=script&lang=js&"
export * from "./InvoiceParameterInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports